import styled from 'styled-components';
import { XIColors } from '@inmoment/the-kitchen';

interface ColorSwatchSmallWrapperType {
  color: string;
  hasBorder: boolean;
}
export const ColorSwatchSmallWrapper = styled.div`
  background: ${(props: ColorSwatchSmallWrapperType) => props.color};
  border: ${(props: ColorSwatchSmallWrapperType) => (props.hasBorder ? `2px solid ${XIColors.orca.primary}` : 'unset')};
  width: 36px;
  height: 36px;
  border-radius: 18px;
  box-sizing: border-box;
`;
